import { render, staticRenderFns } from "./administrators.vue?vue&type=template&id=620c23d1&"
import script from "./administrators.vue?vue&type=script&lang=js&"
export * from "./administrators.vue?vue&type=script&lang=js&"
import style0 from "./administrators.vue?vue&type=style&index=0&id=620c23d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports